import { CustomerPayload } from "models/customer";
import axiosClient from "./axiosClient";
import { ApiResponse } from "models";

const dashBoardApi = {
  getBrandChartData(data: any): Promise<ApiResponse> {
    const url = data?.year
      ? `/dashBoard/getBrandChart?year=${data.year}`
      : `/dashBoard/getBrandChart`;
    return axiosClient.get(url);
  },
  getSalesChartData(data: CustomerPayload): Promise<ApiResponse> {
    const url = `/dashBoard/getAllBrandChartData`;
    return axiosClient.get(url);
  },
  getOrderChartData(data: CustomerPayload): Promise<ApiResponse> {
    const url = `/dashBoard/getOrderChart`;
    return axiosClient.get(url);
  },
  getDashboardStats(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardStats`, { params });
  },
  getDashboardOrders(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardOrders`, { params });
  },
  getDashboardBrands(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardBrands`, { params });
  },
  getDashboardStores(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardStores`, { params });
  },
  getDashboardRegions(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardRegions`, { params });
  },
  getDashboardCustomers(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardCustomers`, { params });
  },
  getDashboardDevices(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardDevices`, { params });
  },
  getDashboardUsers(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardUsers`, { params });
  },
  getDashboardSubscriptions(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardSubscriptions`, { params });
  },
  getDashboardTransactions(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardTransactions`, { params });
  },
  getDashboardActivity(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardActivity`, { params });
  },
  getDashboardInsights(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardInsights`, { params });
  },
  getDashboardAggregators(params?: any): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/getDashboardAggregators`, { params });
  },
  getDashboardCustomization(): Promise<ApiResponse> {
    return axiosClient.get(`/dashBoard/customization`);
  },
  updateDashboardCustomization(data: any): Promise<ApiResponse> {
    return axiosClient.post(`/dashBoard/customization`, data);
  },
};

export default dashBoardApi;
